import { Navigate, Outlet } from 'react-router';
import { usePermissions } from '@/hooks/use-permissions';

// Bug #2: guards the instructor area by the instructor CAPABILITY (literal
// instructor OR admin+), mirroring the API authorization. A pure supervisor —
// who outranks instructor in the display hierarchy but is not one — is redirected
// instead of hitting a 403 dead-end inside the instructor tools.
export function RequireInstructor() {
  const { canInstruct } = usePermissions();

  if (!canInstruct) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
